import { Alignment, Breadcrumbs, Button, Classes, Drawer, Menu, MenuDivider, MenuItem, Navbar, NavbarGroup, NavbarHeading, Position, Switch } from '@blueprintjs/core';
import React, { Component } from 'react';
import { GlobalHotKeys, HotKeys } from 'react-hotkeys';
import { Redirect } from 'react-router';
import { globalKeyMap, keyMap } from '../utils/Constants';
import {
  adminMenuDivider, completeWidth, displayFlex, hotkeyMessage, houstonIconStyle, flexRowCenter, menuMargin,
  menuMarginAdmin, menuSwitch, headerComponentStyle
} from './styles';


const houstonIcon = require('../img/houston_icon.svg');

export default class HeaderComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isNavOpen: false,
      breadcrumbs: props.headerPath,
      hotkeyed: false,
      hotKeyRoute: ''
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      if (this.props.headerPath !== prevProps.headerPath) {
        this.setState({
          breadcrumbs: this.props.headerPath
        });
      }
    }
  }

  showHoustonIcon = () => {
    return (<span><img alt="houston-icon" style={houstonIconStyle} src={houstonIcon} /></span>)
  }

  globalHandlers = {
    OPEN_MENU: () => this.handleOpen()
  };

  keyHandlers = {
    GOTO_EXCEPTIONS: () => this.setState({ hotKeyRoute: '/exceptions' }),
    GOTO_OPEN_TRIPS: () => this.setState({ hotKeyRoute: '/opentrips' }),
    GOTO_LATE_TRIPS: () => this.setState({ hotKeyRoute: '/latetrips' }),
    GOTO_PROVIDER_TRIPS: () => this.setState({ hotKeyRoute: '/provider' }),
    GOTO_OUT_OF_NETWORK: () => this.setState({ hotKeyRoute: '/opentrips' }),
    GOTO_TRIP_SEARCH: () => this.setState({ hotKeyRoute: '/tripsearch' }),
    GOTO_RIDESHARE_TRIPS: () => this.setState({ hotKeyRoute: '/' }),
    GOTO_CLIENTES_PROGRAMS: () => this.setState({ hotKeyRoute: '/' }),
    GOTO_RELAY_USERS: () => this.setState({ hotKeyRoute: '/' }),
    GOTO_MARKETPLACE_USERS: () => this.setState({ hotKeyRoute: '/' }),
  };

  handleOpen = () => this.setState({ isOpen: true });
  handleClose = () => this.setState({ isOpen: false, hotKeyRoute: '' });

  render() {
    if (this.state.hotKeyRoute) {
      this.handleClose();
      return <Redirect to={this.state.hotKeyRoute} />
    }
    return (
      <React.Fragment>
        <GlobalHotKeys keyMap={globalKeyMap} handlers={this.globalHandlers} />
        <Navbar style = {headerComponentStyle} >
          <NavbarGroup align={Alignment.LEFT}>
            <Button
              className={Classes.MINIMAL}
              icon='menu'
              onClick={this.handleOpen}
            />
            <NavbarHeading></NavbarHeading>
            <Breadcrumbs
              items={this.state.breadcrumbs}
              handleNavRoutes={this.handleNavRoutes}
            />
          </NavbarGroup>
          {/* <NavbarGroup align={Alignment.RIGHT}>
            <NavbarDivider />
            <Button className={Classes.MINIMAL} icon='user' />
          </NavbarGroup> */}
        </Navbar>
        <HotKeys keyMap={keyMap} handlers={this.keyHandlers} >
          <Drawer className={this.props.themeName} icon={this.showHoustonIcon()} onClose={this.handleClose} title='&nbsp;Navigation'
            {...this.state} size='auto' position={Position.TOP} >
            <div className={Classes.DRAWER_BODY} style={displayFlex}>
              {/* <Menu style={menuMargin}>
                <MenuDivider title='Customer Service' />
                <MenuItem icon='person' text='Passenger Lookup' label='P' />
                <MenuItem icon='locate' text='Trip Lookup' label='L' />
                <MenuItem icon='send-to-map' text='Trip Entry' label='T' />
                <MenuItem icon='calendar' text='Standing Orders' label='T' />
              </Menu> */}

              <Menu style={menuMargin}>
                <div style={flexRowCenter}>
                  <MenuDivider title='Houston' />
                </div>
                <MenuItem icon='warning-sign' text={<span><u>E</u>xceptions</span>} href='/exceptions' />
                <MenuItem icon='circle' text={<span><u>O</u>pen Trips</span>} href='/opentrips' />
                <MenuItem icon='stopwatch' text={<span><u>L</u>ate Trips</span>} href='/latetrips' />
                <MenuItem icon='known-vehicle' text={<span><u>P</u>rovider Trips</span>} href='/provider' />
                <MenuItem icon='send-to' text={<span>Out of <u>N</u>etwork</span>} href='/opentrips' disabled={true} />
                <MenuItem icon='search' text={<span><u>T</u>rip Search</span>} href='tripsearch' />
              </Menu>

              <Menu style={menuMarginAdmin}>
                <div style={adminMenuDivider}>
                  <MenuDivider title='Admin' />
                </div>
                <MenuItem icon='comparison' text={<span><u>C</u>lients/Programs</span>} disabled={true} />
                <MenuItem icon='add-to-artifact' text={<span><u>R</u>elay Users</span>} disabled={true} />
                <MenuItem icon='application' text={<span><u>M</u>arketplace Users</span>} disabled={true} />
                <div style={hotkeyMessage}><p>*To swap quickly between pages, press "/" and then the underlined letter</p></div>
              </Menu>



              {/* <Menu style={menuMargin}>
                <MenuDivider title='Administration' />
                <MenuItem icon='new-person' text='Relay Users' label='O' />
                <MenuItem icon='office' text='Client Admin' label='E' />
              </Menu>

              <Menu style={menuMargin}>
                <MenuDivider title='Settlement' />
                <MenuItem icon='dollar' text='Settlement Stuff' label='O' />
              </Menu>

              <Menu style={menuMargin}>
                <MenuDivider title='Providers' />
                <MenuItem icon='new-person' text='Bolt Users' label='O' />
                <MenuItem icon='people' text='Provider Stuff' label='O' />
              </Menu>*/}

              <div style={completeWidth}></div>

              <Menu style={menuMargin}>
                <MenuDivider title='My Settings' />
                <Switch checked={this.props.useLightTheme} label='Use Light Theme' style={menuSwitch} onChange={this.props.handleToggleDark} />
              </Menu>
            </div>
          </Drawer>
        </HotKeys>
      </React.Fragment>
    );
  }
}
